const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid']

export const captureUTMs = () => {
  if (typeof window === 'undefined') return
  const params = new URLSearchParams(window.location.search)
  const captured: Record<string, string> = {}
  UTM_KEYS.forEach(key => {
    const val = params.get(key)
    if (val) captured[key] = val
  })
  if (Object.keys(captured).length > 0) {
    sessionStorage.setItem('rng_utms', JSON.stringify(captured))
  }
}

export const getStoredUTMs = (): Record<string, string> => {
  if (typeof window === 'undefined') return {}
  try {
    return JSON.parse(sessionStorage.getItem('rng_utms') || '{}')
  } catch {
    return {}
  }
}
